export default __webpack_public_path__ + "static/media/Harness.1071102c.png";